import { ImagePathWithRenditions } from './ImageTypes';

export type DistinctiveProductDetails = {
  asset: ImagePathWithRenditions;
  description: string;
  heading: string;
  id: string;
};
